import { chartConfig } from "../chart.commonConfig";
import { PATHS, PDF_CONSTANT } from "../../../../constant";
import { chartsLoadedAction } from "../../../../actions/reports.action";
import { CATEGORY_LIMIT } from "../chartHelper";

export const SECOND_PIE_CHART_DASHBOARD_HELPER = (
  data,
  history,
  checkedValue,
  user
) => {
  const PieChartConfig = {
    chart: {
      ...chartConfig.chart,
      type: "pie",
      //height: 400,
      spacingBottom: 10,
      spacingRight: 0,
      spacingLeft: 0,
      animation: {
        duration: 900
      },
      className: "chart-background second-pie-graph",
      events: {
        load: () => {
          chartsLoadedAction({
            type: PDF_CONSTANT.SECOND_PAGE.SECOND._SUCCESS
          });
        }
      }
    },
    title: {
      ...chartConfig.title,
      align: "center",
      text: "",
      useHTML: false,
      style: { color: "#000000", fontSize: "38px", "font-family": "mpb" },
      verticalAlign: "middle",
      y: -10
    },
    subtitle: {
      ...chartConfig.subtitle,
      y: 20,
      x: 135,
      text: "",
      align: "left",
      verticalAlign: "middle",
      style: {
        color: "#000000",
        fontSize: "12px",
        "font-family": "mpr",
        fontWeight: "300"
      }
    },
    plotOptions: {
      series: {
        animation: true,
        duration: 900
        //shadow:true
      },
      pie: {
        allowPointSelect: true,
        shadow: true,

        states: {
          hover: {
            enabled: true
          },
          inactive: {
            enabled: false
          }
        },

        dataLabels: {
          enabled: true,
          distance: -30,

          formatter: function() {
            return this.y; // test first
          },

          style: {
            color: "#fff",
            textOutline: "none",
            fontSize: "19px"
          },

          className: "data-label-text"
        },

        showInLegend: true,

        point: {
          events: {
            legendItemClick: function() {
              this.slice(null);
              return false;
            },

            click: function(event) {
              history.push({
                pathname: PATHS.PROJECT_LIST,
                isDashBoard: true,
                summaryDataBy: false,
                state: {
                  groupCategory: "CENTRAL",
                  sponsoringMinistry:
                    user && user.groupCategory === "CENTRAL"
                      ? [
                          {
                            displayName: user.groupName,
                            key: user.groupId.toString()
                          }
                        ]
                      : null,
                  projectStage: [
                    {
                      displayName: "VERIFIED",
                      key: "VERIFIED"
                    }
                  ],
                  projectFlags: checkedValue
                    ? [
                        {
                          displayName: "MARCH 24",
                          key: "MARCH 24"
                        }
                      ]
                    : null,
                  projectSector:
                    this.name === "Others"
                      ? []
                      : [
                          {
                            displayName: this.name,
                            key: this.sectorId.toString()
                          }
                        ],
                  projectTags: [
                    {
                      displayName: "NOT COMMISSIONED",
                      key: "NOT COMMISSIONED"
                    }
                  ]
                }
              });
            }
          }
        }
      }
    },
    series: [
      {
        name: "Issues",
        // colorByPoint: true,
        data: [],
        startAngle: 90,
        size: "100%",
        innerSize: "50%",
        depth: 50
        // dataLabels: {
        //   enabled: true,
        //   alignTo: "connectors",
        //   format: `<span style="color:{point.color}">{point.y}</span>`
        // }
      }
    ],
    legend: {
      enabled: true,
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      floating: false,

      alignColumns: false,

      width: "100%",
      x: 10,
      itemWidth: 150,
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 4,
      padding: 2,
      itemMarginTop: 0,
      itemMarginBottom: 1,

      itemStyle: {
        lineHeight: "18px",
        color: "#2E384D",
        fontFamily: "mpr",
        fontSize: "17px",
        fontWeight: "300",
        textOverflow: "ellipsis"
      }
    },
    tooltip: {
      formatter: function() {
        return `
                <b>${this.key}</b><br />
                <b>Projects: ${this.y}</b>
              `;
      },
      style: {
        fontSize: "17px"
      }
    }
  };

  try {
    // set data
    const { projectSectorDTOS: list = [], totalProjects = 0 } = data;
    let otherCounts = 0;
    list.forEach(({ sector, projectCount, sectorId }, index) => {
      if (index >= CATEGORY_LIMIT) {
        otherCounts = otherCounts + projectCount;
        PieChartConfig.series[0]["data"][CATEGORY_LIMIT] =
          PieChartConfig.series[0]["data"][CATEGORY_LIMIT] || {};
        PieChartConfig.series[0]["data"][CATEGORY_LIMIT]["name"] = "Others";
        PieChartConfig.series[0]["data"][CATEGORY_LIMIT]["y"] = otherCounts;
      } else {
        PieChartConfig.series[0]["data"].push({
          name: sector,
          y: projectCount,
          sectorId: sectorId
        });
      }
    });
    //PieChartConfig.title.text = `SECTOR DISTRIBUTION : ${totalProjects} PROJECTS`;
    //PieChartConfig.title.text = `${totalProjects}`;
    PieChartConfig.title.text = `${totalProjects}`;
    //PieChartConfig.subtitle.text = `Sector distribution for under construction/under implementation projects`;
    //PieChartConfig.subtitle.text = `TOTAL PROJECTS`;
    if (true) {
      //PieChartConfig.chart.width=300;
    }
    return PieChartConfig;
  } catch (error) {
    console.error(error);
  }
};
